import { createAction } from 'redux-actions';

export const setResourcesAction = createAction('SET_INPUT_RESOURCE');
